module.exports = __webpack_public_path__ + "static/media/measuring-tape.8f8c7885.svg";